module.exports = __webpack_public_path__ + "static/media/world.fd4d8374.jpg";